module.exports = __webpack_public_path__ + "img/gray.a4846fe5.svg";